// import { get } from "lodash";

export default {
  getStateLicenses: (state) => state.stateLicenses.stateLicenses,
  getStateLicensesStates: (state) => state.stateLicenses.states,
  getStateLicensesUpdatedAt: (state) => state.stateLicenses.updatedAt,
};
